import { log } from "~features/seated-reservation/helpers/stateLogger";
import { useAppStore } from "./app-store";

type Payload = string[];

export function removeUnsyncedQueryParams(payload: Payload) {
  log("removeUnsyncedQueryParams", payload);

  const state = useAppStore.getState();

  const url = new URL(window.location.href);

  const newQuery = Object.fromEntries(
    Object.entries(state.unsyncedQueryParams).filter(([key, value]) => {
      if (payload.includes(key)) {
        url.searchParams.delete(key);
        return false;
      }
      url.searchParams.set(key, value);
      return true;
    })
  );

  const pathname = url.pathname;
  const search = url.search;
  const asPath = pathname + search;

  // Need to use this instead of {} as the first parameter of replaceState when working with Next.js.
  // Otherwise, clicking the browser's back button will change the URL, but the page won't reload.
  // https://github.com/vercel/next.js/discussions/18072#discussioncomment-109059
  window.history.replaceState(
    {
      ...window.history.state,
      as: asPath,
      url: asPath,
    },
    "",
    asPath
  );

  useAppStore.setState({
    unsyncedQueryParams: newQuery,
  });
}
